import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { loadIndustriesTypes } from "../IndustryTypes/loadData";
import { AddIndustry } from "./AddIndustry";
import { loadIndustries } from "./loadData";
import { IndustryHeaders } from "./tableHeaders";

const Industries = ({}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [industries, setIndustries] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);
  console.log(industries);

  useEffect(() => {
    loadIndustries(setLoading).then(setIndustries);
  }, [location.pathname, update]);

  const [allIndustryTypes, setAllIndustryTypes] = useState([]);
  useEffect(() => {
    loadIndustriesTypes(setLoading).then(setAllIndustryTypes);
  }, [location.pathname]);

  return (
    <AdminPage title="Industries">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Industry Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.industryName}
            description={viewModalData?.industryDescription}
            type={viewModalData?.industryType?.typeName}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete Industry"}
        InternalComponent={
          <DeleteModalContent
            route={`industry/deleteIndustry/${deleteData?._id}`}
            type={"Industry"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />
      {allIndustryTypes.length > 0 && (
        <AddIndustry
          opened={opened}
          setOpened={setOpened}
          allIndustryTypes={allIndustryTypes}
          setUpdate={setUpdate}
          editData={editData}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          editModalState={editModalState}
          setLoading={setLoading}
        />
      )}
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={IndustryHeaders}
          rowData={industries}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
          showAddButton={true}
          opened={opened}
          setOpened={setOpened}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(Industries);
